import * as React from 'react';
export const triodosSvg = React.forwardRef(function triodosSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00937B',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M26.18 16.4a10.8 10.8 0 0 0-2.88-7.32 10.1 10.1 0 0 0-3.36-2.29l-.14.26c.65.41 1.19.82 1.84 1.46a10.87 10.87 0 0 1 3.01 7.26c0 .36 0 1.13-.04 1.67a6.52 6.52 0 0 0-1.79-3.11c-.27-.26-.64-.67-.93-.8a10 10 0 0 1-.46 2.53c.34.27.55.5.87.8a4.02 4.02 0 0 1 1.25 2.6c0 .47-.2.96-.58 1.33-.38.39-1.17.68-1.94.68a5.96 5.96 0 0 1-3-1.03c2-2.01 3.15-4.73 3.2-7.57 0-1.55-.39-3-1.03-4.16a5.3 5.3 0 0 0-4.78-2.9c-2.5 0-4.85 1.24-6.6 3a9.96 9.96 0 0 0-2.91 8.44h.29c.02-.78.13-1.57.33-2.33a10.9 10.9 0 0 1 2.85-4.7c1.02-1 2.2-1.8 3.5-2.37a6.4 6.4 0 0 0-2.12 4.31c.47-.3 1.66-.71 2.42-.84.14-1.1.55-2.29 1.37-3.1.39-.4.87-.66 1.46-.66.9 0 1.6.66 2.06 1.41.45.79.72 2.19.6 3.13a10.27 10.27 0 0 0-10.02 2.4 6.52 6.52 0 0 0-2.07 4.42c0 1.72.88 3.17 2.04 4.36 2 1.9 4.66 2.94 7.42 2.91 2.2 0 4.16-.75 5.95-2.05l-.15-.25a9.23 9.23 0 0 1-4.6 1.17c-2.44.02-4.83-.74-6.8-2.18.58.17 1.2.26 1.69.26a7.4 7.4 0 0 0 3.05-.67c-.5-.32-1.45-1.08-1.95-1.67-.71.29-1.6.5-2.35.5s-1.55-.17-2.07-.7c-.31-.36-.49-.8-.5-1.27 0-1 .56-1.84 1.21-2.5.47-.5 1.1-.95 1.6-1.2.56 2 1.46 3.6 2.91 5.06a9.16 9.16 0 0 0 6.2 2.77 5.18 5.18 0 0 0 3.98-1.53 8.15 8.15 0 0 0 1.98-5.51zm-7.8-1.65a10 10 0 0 1-2.54 4.01 9.67 9.67 0 0 1-2.2-4.19c1.58-.3 3.2-.23 4.75.18h-.02z',
      }),
    ),
  );
});
triodosSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var triodos = {
  category: 'brand',
  colorable: false,
  name: 'triodos',
  svg: triodosSvg,
};
